<table
	mat-table
	class="list-container mb-3"
	[dataSource]="dataSource"
	matSort
	matSortActive="{{ sort.active }}"
	matSortDisableClear
	matSortDirection="{{ sort.direction }}"
>
	<ng-container matColumnDef="empty">
		<th mat-header-cell *matHeaderCellDef class="text-center">
			<div class="list-loader" *ngIf="loading$ | async">
				<mat-progress-bar mode="indeterminate"></mat-progress-bar>
			</div>
			<em *ngIf="loading$ | async">Loading jobs...</em>
			<em *ngIf="!(loading$ | async)">No associated jobs</em>
		</th>
	</ng-container>

	<ng-container matColumnDef="number">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Number</th>
		<td mat-cell *matCellDef="let job">
			<ng-container *ngIf="job.number > 0">
				<a [routerLink]="jobsFragments.detail(job.id)">
					{{ job.number }}
				</a>
			</ng-container>
			<ng-container *ngIf="job.number === 0">
				<mat-chip-list>
					<mat-chip
						color="primary"
						selected
						[routerLink]="quotesFragments.detail(job.id)"
					>
						QUOTE
					</mat-chip>
				</mat-chip-list>
			</ng-container>
		</td>
	</ng-container>

	<ng-container matColumnDef="description">
		<th mat-header-cell *matHeaderCellDef>Description</th>
		<td mat-cell *matCellDef="let job">
			{{ job.description }}
		</td>
	</ng-container>

	<ng-container matColumnDef="status">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
		<td mat-cell *matCellDef="let job">
			{{ job.status | filterFn: displayJobStatusAdmin }}
		</td>
	</ng-container>

	<ng-container matColumnDef="start">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
		<td mat-cell *matCellDef="let job">
			{{ job.start | date: 'shortDate':'utc' }}
		</td>
	</ng-container>

	<ng-container matColumnDef="end">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
		<td mat-cell *matCellDef="let job">
			{{ job.end | date: 'shortDate':'utc' }}
		</td>
	</ng-container>

	<tr
		mat-header-row
		*matHeaderRowDef="resultColumns"
		[class.hidden]="dataSource.data.length < 1"
	></tr>
	<tr
		mat-header-row
		*matHeaderRowDef="emptyColumns"
		[class.hidden]="dataSource.data.length > 0"
	></tr>
	<tr mat-row *matRowDef="let job; columns: resultColumns"></tr>
</table>

<div fxLayout fxLayoutAlign="space-between center">
	<mat-paginator
		class.hidden="true"
		pageSize="5"
		[pageSizeOptions]="[5, 10]"
	></mat-paginator>
</div>
